import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import certificate1 from "../../image/Certificate/ISO Certificate.jpeg";
import certificate2 from "../../image/Certificate/trademark.jpeg";

function Carousel1() {
  const [show, setShow] = useState(false);
  const [getImageIndex, setGetImageIndex] = useState(null);

  const sliderSettings = {
    arrows: false,
    dots: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    lazyLoad: "progressive",
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          dots: false,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          dots: false,
        },
      },
    ],
  };

  const hotelCards = [
    {
      imageSrc: certificate1,
      title: "ISO 9001:2015 Certificate",
      subtitle: "Quality Management System"
    },
    {
      imageSrc: certificate2,
      title: "Quality Accreditation",
      subtitle: "Registered Trademark Mark"
    },
  ];

  const ClickZoomButton = (card) => {
    setShow(true);
    setGetImageIndex(card.imageSrc);
  };

  return (
    <section className="w-full bg-slate-50/50 py-20 px-6 sm:px-12 relative overflow-hidden">
      {/* Decorative Soft Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-orange-100/40 rounded-full blur-[140px] pointer-events-none"></div>

      <div className="max-w-7xl mx-auto flex flex-col items-center justify-center relative z-10">

        {/* Header Tag & Title */}
        <div className="flex flex-col mb-4 text-center space-y-2">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold tracking-wider uppercase bg-orange-100 text-orange-700 mx-auto">
            Accreditation & Standards
          </span>
          <h2 className="text-3xl sm:text-4xl font-black text-slate-900 tracking-tight">
            Certified Excellence
          </h2>
        </div>

        {/* Description Block */}
        <div className="w-full max-w-3xl mb-12 text-slate-600 text-sm sm:text-base leading-relaxed text-center font-normal">
          <p>
            We are a leading PVC & PE pipe manufacturer in India, operating state-of-the-art, ISO 9001:2015 certified facilities in West Bengal. Our complete product line strictly conforms to both National and International Standards (BIS).
          </p>
        </div>

        {/* Carousel Slide Stage */}
        <div className="w-full xl:w-2/3 px-2">
          <Slider className="border-none" {...sliderSettings}>
            {hotelCards.map((card, index) => (
              <div key={index} className="px-3 py-4 focus:outline-none">
                <div className="group bg-white rounded-2xl border border-slate-200/80 p-3 shadow-lg shadow-slate-200/50 hover:shadow-2xl hover:shadow-orange-500/10 transition-all duration-300 relative overflow-hidden flex flex-col">

                  {/* Image Display */}
                  <div className="relative aspect-[3/4] bg-slate-50 rounded-xl overflow-hidden flex items-center justify-center p-3 border border-slate-100">
                    <img
                      src={card.imageSrc}
                      alt={card.title}
                      className="max-w-full max-h-full object-contain rounded-lg transition-transform duration-500 group-hover:scale-102"
                    />

                    {/* Expand Trigger Button */}
                    <button
                      onClick={() => ClickZoomButton(card)}
                      className="absolute right-4 top-4 bg-slate-900/80 backdrop-blur-md text-white p-2.5 rounded-xl shadow-lg hover:bg-orange-600 transition-colors cursor-pointer border border-white/10"
                      aria-label={`Zoom ${card.title}`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="2.5"
                        stroke="currentColor"
                        className="w-4 h-4"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"
                        />
                      </svg>
                    </button>
                  </div>

                  {/* Card Title Label */}
                  <div className="pt-3 px-1 pb-1 text-center">
                    <h3 className="font-bold text-slate-900 text-sm">{card.title}</h3>
                    <p className="text-[11px] text-slate-500 font-medium">{card.subtitle}</p>
                  </div>

                </div>
              </div>
            ))}
          </Slider>
        </div>

      </div>

      {/* Lightbox Modal View */}
      {show && (
        <div className="fixed inset-0 z-50 bg-slate-950/80 backdrop-blur-md flex items-center justify-center p-4">
          <div
            className="fixed inset-0 w-full h-full cursor-pointer"
            onClick={() => setShow(false)}
          ></div>

          <div className="relative w-full max-w-2xl mx-auto bg-white p-4 sm:p-6 rounded-3xl shadow-2xl z-10 border border-slate-100">

            {/* Modal Close Button */}
            <button
              onClick={() => setShow(false)}
              className="absolute -top-12 right-0 bg-white/20 hover:bg-white/30 text-white rounded-full p-2 backdrop-blur-md transition-colors cursor-pointer"
              aria-label="Close presentation view"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2.5" stroke="currentColor" className="w-5 h-5">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <div className="w-full overflow-hidden rounded-2xl max-h-[75vh] flex items-center justify-center bg-slate-50 p-2 border border-slate-100">
              <img
                alt="Accreditation Certificate Full Size View"
                className="max-w-full max-h-[70vh] object-contain rounded-lg shadow-sm"
                src={getImageIndex}
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Carousel1;